export default __webpack_public_path__ + "static/media/image_8.23663e73.jpg";